import React from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import { useState, useEffect, useReducer } from "react";
import { Form } from "react-bootstrap";
import "antd/dist/antd.css";
import "../NewDashboard/styles-for-new-dashboard.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import mainLogoSerpMaze from "../NewDashboard/Telescope-frontpage.png";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import { Tag } from "antd";
import { Fragment } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  Bars3BottomLeftIcon,
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  UsersIcon,
  XMarkIcon,
  CodeBracketIcon,
  ComputerDesktopIcon,
  PlusCircleIcon,
  PlusSmallIcon,
} from "@heroicons/react/24/outline";

import {
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
  DashOutlined,
  DesktopOutlined,
  FileOutlined,
  PieChartOutlined,
  TeamOutlined,
  HeartOutlined,
  CaretDownOutlined,
  MonitorOutlined,
  FundTwoTone,
  RiseOutlined,
  DotChartOutlined,
  AreaChartOutlined,
  MailOutlined,
  CompassOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  SearchOutlined,
  CaretRightOutlined,
  QuestionCircleOutlined,
  ArrowRightOutlined,
  RedoOutlined,
  PlusCircleOutlined,
  GlobalOutlined,
  CheckOutlined,
  MoreOutlined,
} from "@ant-design/icons";
import { Layout, Modal, Table } from "antd";
import { Input } from "antd";
import { Row as AntdRow, Col as AntdCol, Card, Alert as AntdAlert } from "antd";
import {
  Container,
  OverlayTrigger,
  Badge,
  ProgressBar,
  Alert,
  Row,
  Col,
} from "react-bootstrap";
import { PieChart } from "react-minimal-pie-chart";
import { Button } from "antd";
import { Dropdown, Space, message, Drawer } from "antd";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  AreaChart,
  ReferenceLine,
  Area,
} from "recharts";
import googleDomainsForSelector from "../FreeSerpChecker/google-domains2.json";
import Select from "react-select";
import Loading from "../SpinnerAndError/Loading";
import ReportPageFromInsideApp from "../reportPageFromInsideApp/ReportPageFromInsideApp";

const { Header, Content, Footer, Sider } = Layout;

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const QuickReportsPage = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [keyForWhatReportToFetch, setKeyForWhatReportToFetch] = useState(0);
  const [loadings, setLoadings] = useState([]);
  const [URLNotFound, setURLNotFound] = useState(false);
  const [selectedMednuItem, setSelectedMenuItem] = useState("Competitors");
  const [newDataSourceForTheTable, setNewDataSourceForTheTable] = useState([]); //DATA FOR THE KEYWORD TABLE

  const [isModalOpen, setIsModal1Open] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);
  const [isModal4Open, setIsModal4Open] = useState(false);
  const [domainNameEntered, setDomainNameEntered] = useState("");
  const [competitorFromInput, setCompetitorFromInput] = useState("");
  const [showModalNextButton, setShowModalNextButton] = useState(true);
  const [selectedGoogleDomain, setSelectedGoogleDomain] = useState();
  const [googleRegionsChosen, setGoogleRegionsChosen] = useState(false);
  const [deviceChosen, setDeviceChosen] = useState(false);
  const [country, setCountry] = useState("United States");
  const [googleDomain, setGoogleDomain] = useState("google.com");
  const [languageCode, setlanguageCode] = useState("en");
  const [countryCode, setCountryCode] = useState("us");
  const [device, setDevice] = useState("Mobile");
  const [editedKeywordsHasBeenChanged, setEditedKeywordsHasBeenChanged] =
    useState(false);
  const [keywordsFromModal, setKeywordsFromModal] = useState([]);
  const [loading, setLoading] = useState(false);
  const [overallLoading, setOverallLoading] = useState(false);
  const [loadingAfterModal4, setLoadingAfterModal4] = useState(false);
  const [urlDoesNotExist, setUrlDoesNotExist] = useState(false);
  const [competitorDoesNotExist, setCompetitorDoesNotExist] = useState(false);
  const [browserTimedOut, setBrowserTimedOut] = useState(false);
  const [errorInFetching, setErrorInFetching] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [
    cannotUpdateNowHaveToWait24Hours,
    setCannotUpdateNowHaveToWait24Hours,
  ] = useState(false);
  const [
    lastTimeReportWasGeneratedPlus24Hours,
    setLastTimeReportWasGeneratedPlus24Hours,
  ] = useState("");
  //THESE BELOW ARE BEING SET ON COMPONENT DID MOUNT:
  const [isCustomerPaying, setIsCustomerPaying] = useState(false);
  const [payingUser, setPayingUser] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState("");
  const [keywords, setKeywords] = useState([]);
  const [trackingInformation, setTrackingInformation] = useState();
  const [email, setEmail] = useState();
  const [overallSEOScore, setOverallSEOScore] = useState();
  const [numberOfSuccessfullTests, setNumberOfSuccessfullTests] = useState();
  const [numberOfFailedTests, setNumberOfFailedTests] = useState();
  const [trackedWebsite, setTrackedWebsite] = useState();
  const [timeReportWasGenerated, setTimeReportWasGenerated] = useState();
  const [historyOfReports, setHistoryOfReports] = useState([]);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  // This below is the "Quickly Analyse" input field in the top for None-First Time users
  const [quicklyAnalyseInputField, setQuicklyAnalyseInputField] = useState("");
  const [isQuickReportModalOpen, setIsQuickReportModalOpen] = useState(false);

  //ALL THE STATES BELOW NEEDED TO RENDER THE REPORT :

  const [urlInput, setUrlInput] = useState("");
  const [arrayWithAllHInformation, setArrayWithAllHInformation] = useState();
  const [faviconFromWebsite, setFaviconFromWebsite] = useState("");
  const [h1Length, setH1Length] = useState();
  const [h2Length, setH2Length] = useState();
  const [h3Length, setH3Length] = useState();
  const [h4Length, setH4Length] = useState();
  const [h5Length, setH5Length] = useState();
  const [h6Length, setH6Length] = useState();
  const [imageSrcAndAltTexts, setImageSrcAndAltTexts] = useState();
  const [isHttpsSupported, setIsHttpsSupported] = useState();
  const [metaDescription, setMetaDescription] = useState("");
  const [metaTitle, setMetaTitle] = useState("");
  const [numberOfEmptyAltTexts, setNumberOfEmptyAltTexts] = useState();
  const [outGoingNoFollowLinks, setOutGoingNoFollowLinks] = useState();
  const [robotsTXTExists, setRobotsTXTExists] = useState(false);
  const [externalLinks, setExternalLinks] = useState();
  const [internalLinks, setInternalLinks] = useState();
  const [mostCommonKeywords, setMostCommonKeywords] = useState();
  const [sslInfo, setSslInfo] = useState({});
  const [numberOfWarningTests, setNumberOfWarningTests] = useState(0);
  const [numberOfSuccessTests, setNumberOfSuccessTests] = useState(0);
  const [timeRightNowForReport, setTimeRightNowForReport] = useState();

  const [showFullListOfHeadings, setShowFullListOfHeadings] = useState(false);
  const [showFullListOfImageAltTexts, setShowFullListOfImageAltTexts] =
    useState(false);
  const [showFullListOfKeywords, setShowFullListOfKeywords] = useState(false);
  const [showFullListOfInternalLinks, setShowFullListOfInternalLinks] =
    useState(false);
  const [showFullListOfExternalLinks, setShowFullListOfExternalLinks] =
    useState(false);
  const [
    showFullListOfOutgoingNoFollowLinks,
    setShowFullListOfOutgoingNoFollowLinks,
  ] = useState(false);
  //THESE 2 BELOW ARE SET WITHIN THE INITIAL FETCH ON MOUNT:
  const [SSLValidFrom, setSSLValidFrom] = useState("");
  const [SSLValidTo, setSSLValidTo] = useState("");
  // UNTIL HERE**********************

  // UNTIL HERE //ALL THE STATES BELOW NEEDED TO RENDER THE REPORT.

  // sider and drawer toggle
  const [visible, setVisible] = useState(false);
  const [isToggled, setToggled] = useState(false);

  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const navigation = [
    { name: "Dashboard", icon: HomeIcon, href: "/dashboard", current: false },
    {
      name: "Keyword tracker",
      icon: ChartBarIcon,
      href: "/keyword-tracker",
      current: false,
    },
    {
      name: "Reports",
      icon: UsersIcon,
      href: "/saved-reports",
      current: true,
    },
    {
      name: "Meta-tag generator",
      icon: ComputerDesktopIcon,
      href: "/meta-checker",
      current: false,
    },
    {
      name: "Schema Markup",
      icon: CodeBracketIcon,
      href: "/schema-generator",
      current: false,
    },
  ];

  const avatarOnClickFunction = (event) => {
    const eventName = event.target.innerText;

    if (eventName === "Sign out") {
      logoutFunction();
    }
  };

  const userNavigation = [
    { name: "Your Profile", href: "/profile" },
    /* { name: "Settings", href: "#" }, */
    { name: "Sign out", href: "#" },
  ];

  const secondaryNavigation = [
    {
      name: "something",
      href: "#",
    },
    /* { name: "GraphQL API", href: "#" },
  { name: "Customer migration guides", href: "#" },
  { name: "Profit sharing program", href: "#" }, */
  ];

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "IGNORE" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    setOverallLoading(true); // TURNING ON LOADER HERE
    fetchDataOnMount();
  }, [reRender]);

  //THIS IS THE FETCH DATA FUNCTION, THAT IE BEING CALLED ON COMPONENT DID MOUNT: *************************
  const fetchDataOnMount = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_FETCH_EXISTING_QUICK_REPORTS_ON_MOUNT,
        {
          method: "GET",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setOverallLoading(false); // TURNING OFF LOADER HERE
        setFirstTimeUser(data.firstTimeUser);
        setPayingUser(data.isCustomerPaying);
        /* setSubscriptionType(data.paymentInformation.subscriptionType); */
        setEmail(data.email);

        //SETTING THE KWYWORDS IN STATE BELOW:
        const quickReportsFromBackend = data.quickReports;
        /* console.log("array of keywords: ", arrayOfKeywordsFromBackend); */
        if (Object.keys(quickReportsFromBackend).length > 0) {
          quickReportsFromBackend.map((e, index) => {
            setNewDataSourceForTheTable((data) => [
              ...data,
              {
                index: index + 1,
                url: e.website,

                createdat: e.timeReportWasGenerated,
                score: e.overallSEOScore,
                passed: e.numberOfSuccessfullTests,
                failed: e.numberOfFailedTests,
                action: "View report",
              },
            ]);
          });
        }
      } else if (response.status === 401) {
        console.log("Token not valid");
        window.location.replace("/login"); // I AM ADDING THIS ONE , SO THAT THE USER WILL BE REDIRECTED TO THE LOGIN PAGE IN CASE THE TOKEN IS EXPIRED.
      }
    } catch (error) {
      console.log(error);
    }
  };

  //THIS IS T HE FUNCTION THAT OPENS UP THE DELETE SITE MODAL :

  const showDeleteSiteFunction = () => {
    setShowDeleteModal(true);
    /* console.log("hello"); */
  };

  //THIS IS THE MODAL INFORMATION:
  const showModal1 = () => {
    setIsModal1Open(true);
    setIsModal2Open(false);
  };

  const showModal2 = () => {
    setIsModal1Open(false);
    setIsModal3Open(false);
    setIsModal2Open(true);
    setIsModal4Open(false);
  };

  const showModal3 = () => {
    setIsModal2Open(false);
    setIsModal4Open(false);
    setIsModal3Open(true);
  };
  const showModal4 = () => {
    setIsModal3Open(false);
    setIsModal2Open(false);
    setIsModal4Open(true);
  };

  const handleOk = () => {
    setIsModal1Open(false);
    setShowDeleteModal(false);
    setIsQuickReportModalOpen(false);
    setKeyForWhatReportToFetch(0);
  };

  const handleCancel = () => {
    setIsModal1Open(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setShowDeleteModal(false);
    setIsQuickReportModalOpen(false);
    setKeyForWhatReportToFetch(0);
  };

  const onChangeFunctionForUrlInput = (event) => {
    const result = event.target.value; /* .replace(
      /[!@#$%^&*()_+\=\[\]{};':"\\|,€<>\/?]+/,
      ""
    ); */
    setDomainNameEntered(result);
  };

  const onChangeFunctionForCompetitorInput = (event) => {
    const result = event.target.value.replace(
      /[!@#$%^&*()_+\-=\[\]{};':"\\|,€<>\/?]+/,
      ""
    );
    setCompetitorFromInput(result);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const menu = (
    <Menu
      onClick={logoutFunction}
      items={[
        /*         {
          label: "My account",
          key: "1",
        }, */
        /* {
          label: "Billing",
          key: "2",
        }, */
        {
          label: (
            <span style={{ color: "red" }} onClick={logoutFunction}>
              Logout
            </span>
          ),
          key: "3",
        },
      ]}
    />
  );
  function getItem(label, key, icon, items) {
    return {
      key,
      icon,
      items,
      label,
    };
  }

  const customStylesWhenNotDisabled = {
    control: (base, state) => ({
      ...base,

      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  const options = googleDomainsForSelector.sort((a, b) => {
    if (a.value.country_name < b.value.country_name) {
      return -1;
    }
    if (a.value.country_name > b.value.country_name) {
      return 1;
    }
    return 0;
  });

  const onChangeForGoogleRegion = (event) => {
    /* console.log(event); */
    setGoogleRegionsChosen(true);
    setCountry(event.value.country_name);
    setGoogleDomain(event.value.domain);
    setCountryCode(event.value.country_code);
    setlanguageCode(event.value.language_code);
  };

  //FOR THE DEVICE INPUT FIELD
  const deviceOptions = [
    { value: "Desktop", label: "Desktop" },
    { value: "Mobile", label: "Mobile" },
    { value: "Tablet", label: "Tablet" },
  ];

  const onChangeOfDeviceHandler = (change) => {
    setDevice(change.value);
    setDeviceChosen(true);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  const handleSubmitForModal1 = (e) => {
    setUrlDoesNotExist(false);
    setErrorInFetching(false);
    e.preventDefault();
    setLoading(true);
    if (
      showModalNextButton === true &&
      domainNameEntered.length >= 4 &&
      !domainNameEntered.includes("@") &&
      !domainNameEntered.includes("!")
    ) {
      checkIfUrlExistsFunction();
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 1 ***************************:
  const checkIfUrlExistsFunction = async () => {
    console.log("working");

    const bodyData = {
      url: domainNameEntered,
    };

    try {
      const response = await fetch(process.env.REACT_APP_CHECK_IF_URL_EXISTS, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        console.log("url exists");
        setLoading(false);
        showModal2();
      } else if (response.status === 404) {
        console.log("Url does not exist");
        setUrlDoesNotExist(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 2 ***************************:
  const handleSubmitForModal2 = (e) => {
    e.preventDefault();
    setLoading(true);
    if (deviceChosen === true && googleRegionsChosen === true) {
      saveGoogleRegionAndDeviceInUsersProfile();
    }
  };

  const saveGoogleRegionAndDeviceInUsersProfile = async () => {
    const bodyData = {
      trackedUserDomain: domainNameEntered,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_SET_GOOGLE_REGION_AND_DEVICE_IN_USER_PROFILE,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        console.log("data saved");
        setLoading(false);
        showModal4();
      } else if (response.status === 404) {
        setLoading(false);
        setErrorInFetching(true);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 3 ***************************:
  const handleSubmitForModal3 = (e) => {
    /* console.log("Event", e.target.value); */
    setCompetitorDoesNotExist(false);
    setErrorInFetching(false);
    e.preventDefault();
    setLoading(true);
    if (competitorFromInput.length < 1) {
      setLoading(false);
      showModal4();
    } else {
      checkIfCompetitorExistsFunction();
    }
  };

  //THIS FUNCTION CHECK IF THE COMPETITOR URL EXISTS IN MODAL 3 ***************************:
  const checkIfCompetitorExistsFunction = async () => {
    const bodyData = {
      url: competitorFromInput,
    };

    try {
      const response = await fetch(process.env.REACT_APP_CHECK_IF_URL_EXISTS, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        console.log("competitor URL exists");
        setLoading(false);
        showModal4();
      } else if (response.status === 404) {
        console.log("Competitor URL does not exist");
        setCompetitorDoesNotExist(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  //THIS IS THE FUNCTION USED FOR THE 4TH MODAL FOR WHEN ADDING KEYWORDS
  const pushKeywordsFromModalFourToArrayFunction = (
    propertyName,
    targetValue
  ) => {
    setEditedKeywordsHasBeenChanged(true);
    setKeywordsFromModal({
      ...keywordsFromModal,
      [propertyName]: targetValue,
    });
  };

  //THIS IS TEH FUNCTION WHEN YOU CLICK THE "FINISH SETUP" BUTTON IN MODAL 4.

  const setupAllInformationAfterModal4Function = async () => {
    setLoading(true);
    setOverallLoading(true);
    const bodyData = {
      domainUrl: domainNameEntered,
      email: email, //used to identify the user on the backend.
      keywords: keywordsFromModal,
      trackedUserDomain: domainNameEntered,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };
    try {
      const response = await fetch(
        process.env.REACT_APP_FINISH_SETUP_OF_NEW_USER,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        setLoading(false);
        setOverallLoading(false);
        console.log("Everything saved in MongoDB!");
        const update = await response.json();

        setRerender([update]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        setOverallLoading(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setOverallLoading(false);
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  // THIS IS THE "QUICKLY ANALYSE A DOMAIN FUNCTION" BELOW *********************
  const quicklyAnalyseInputFieldFunction = async () => {
    console.log(quicklyAnalyseInputField);
    setLoading(true);
    setOverallLoading(true);

    const bodyData = {
      quicklyAnalyseURL: quicklyAnalyseInputField,
    };
    try {
      const response = await fetch(process.env.REACT_APP_QUICKLY_ANALYSE_URL, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        setLoading(false);
        setOverallLoading(false);
        console.log("Everything saved in MongoDB!");
        const data = await response.json();
        window.location.href = "/saved-reports";

        /*  setRerender([update]); */ // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        message.warning(
          "Browser timed out. The site might be down momentatily, or you might be on a slow connection. Please try again later.",
          10
        );

        setOverallLoading(false);
        setLoading(false);
      } else if (response.status === 404) {
        setURLNotFound(true);
        message.error("URL not found. Are you sure you spelled it correctly?");
        setOverallLoading(false);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setOverallLoading(false);
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const runReportAgainFunction = async () => {
    setLoading(true);
    const bodyData = {
      trackedWebsite: trackedWebsite,
      email: email, //used to identify the user on the backend.
    };
    try {
      const response = await fetch(process.env.REACT_APP_RUN_REPORT_AGAIN, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        setLoading(false);
        const update = await response.json();
        setRerender([update]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 206) {
        setLoading(false);
        const data = await response.json();
        console.log("cannot update now - have to wait 24 hours.");
        setLastTimeReportWasGeneratedPlus24Hours(data.lastTimePlus24Hours);
        setCannotUpdateNowHaveToWait24Hours(true);
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const viewReportFromSummaryCardFunction = (event) => {
    event.preventDefault();
    console.log("Working");
    window.location.href = "/report";
  };

  const sendUserToTheKeywordTrackingFunction = (event) => {
    event.preventDefault();
    window.location.href = "/keyword-tracker";
  };

  // THESE ARE THE COLUMNS USED FOR THE TABLE
  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      /* width: 100, */
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      /* width: 100, */
    },
    {
      title: "Created at",
      dataIndex: "createdat",
      key: "createdat",
      /* width: 100, */
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      /* width: 100, */
    },
    {
      title: "Passed",
      dataIndex: "passed",
      key: "passed",
      /* width: 100, */
    },
    {
      title: "Failed",
      dataIndex: "failed",
      key: "failed",
      /* width: 100, */
    },
    /* {
      title: "Warnings",
      dataIndex: "warnings",
      key: "warnings",
      
    }, */
    {
      title: "Action",
      /* dataIndex: "action", */
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size="middle">
          <span

          /* className="remove-item-box-for-deleting-a-keyword" */
          >
            {/*             <Button type="text" onClick={openOpTheQuickReportModal}>
              View Report
            </Button> */}
            <Tag
              color="success"
              style={{ cursor: "pointer" }}
              onClick={openOpTheQuickReportModal}
            >
              View Report
            </Tag>
          </span>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (keyForWhatReportToFetch !== 0) {
      console.log(keyForWhatReportToFetch);
      fetchQuickReportData();
    }
  }, [keyForWhatReportToFetch]);

  const openOpTheQuickReportModal = (event) => {
    event.preventDefault();
    const key = event.target.closest("tr").childNodes.item(0).innerText;
    const keyToUse = key - 1;

    setKeyForWhatReportToFetch(key);

    /*    fetchQuickReportData(); */
  };

  const fetchQuickReportData = async () => {
    const bodyData = {
      key: keyForWhatReportToFetch,
    };

    const response = await fetch(
      process.env.REACT_APP_FETCH_A_SPECIFIC_QUICK_REPORT,
      {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      }
    );
    if (response.ok) {
      setIsQuickReportModalOpen(true);
      const data = await response.json();
      setOverallLoading(false); // TURNING OFF LOADER HERE.
      setIsCustomerPaying(data?.isCustomerPaying);
      setFirstTimeUser(data?.firstTimeUser);
      setEmail(data?.email);

      setUrlInput(data?.quickReport?.website);
      setArrayWithAllHInformation(data?.quickReport?.arrayOfHTagElements);
      setFaviconFromWebsite(data?.quickReport?.favicon);
      setH1Length(data?.quickReport?.h1Length);
      setH2Length(data?.quickReport?.h2Length);
      setH3Length(data?.quickReport?.h3Length);
      setH4Length(data?.quickReport?.h4Length);
      setH5Length(data?.quickReport?.h5Length);
      setH6Length(data?.quickReport?.h6Length);
      setImageSrcAndAltTexts(data?.quickReport?.imagesSrcAndAltTexts);
      setIsHttpsSupported(data?.quickReport?.isHttpsSupported);
      setMetaDescription(data?.quickReport?.metaDescription);
      setMetaTitle(data?.quickReport?.metaTitle);
      setNumberOfEmptyAltTexts(data?.quickReport?.numberOfEmptyAltTexts);
      setOutGoingNoFollowLinks(data?.quickReport?.outGoingNoFollowLinks);
      setRobotsTXTExists(data?.quickReport?.robotsTXTExists);
      setExternalLinks(data?.quickReport?.sortedExternalLinks);
      setInternalLinks(data?.quickReport?.sortedInternalLinks);
      setMostCommonKeywords(data?.quickReport?.sortedKeywords);
      setSslInfo(data?.quickReport?.sslInfo);
      setOverallSEOScore(data?.quickReport?.overallSEOScore);
      setNumberOfSuccessTests(data?.quickReport?.numberOfSuccessfullTests);
      setNumberOfFailedTests(data?.quickReport?.numberOfFailedTests);
      setTimeRightNowForReport(data?.quickReport?.timeReportWasGenerated);
      setOverallSEOScore(data?.quickReport?.overallSEOScore);
      setNumberOfSuccessTests(data?.quickReport?.numberOfSuccessfullTests);
      setNumberOfFailedTests(data?.quickReport?.numberOfFailedTests);
      /* setTimeRightNowForReport(data?.quickReport?.timeReportWasGenerated); */
      /* setHistoryOfReports(data?.historyOfReports); */

      const SSLValidFrom = moment(sslInfo?.validFrom).format("MMMM Do YYYY");
      const SSLValidTo = moment(sslInfo?.validTo).format("MMMM Do YYYY");
      setSSLValidFrom(SSLValidFrom);
      setSSLValidTo(SSLValidTo);
    }
  };

  const removeSiteFunction = async () => {
    setIsModal1Open(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setShowDeleteModal(false);

    const bodyData = {
      website: trackedWebsite,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_DELETE_A_SITE_FROM_DASHBOARD,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        console.log("Done");
        const data = await response.json();
        console.log(data);
        setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      }
    } catch (error) {
      console.log(error);
      setErrorInFetching(true);
    }
  };

  const dropdownMenuForSmallNavForTheWebsite = (
    <Menu
      style={{ maxWidth: "20px" }}
      items={[
        {
          key: "1",
          label: (
            <a rel="noopener noreferrer" href="/report">
              Report
            </a>
          ),
        },
        {
          key: "2",
          label: (
            <a rel="noopener noreferrer" href="/keyword-tracker">
              Keyword tracker
            </a>
          ),
        },
        {
          key: "3",
          label: (
            <a rel style={{ color: "red" }} onClick={showDeleteSiteFunction}>
              Remove site
            </a>
          ),
        },
      ]}
    />
  );

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard");
  };

  //THESE BELOW ONES ARE FOR THE ONCLICKS ON THE REPORT TO SEE MORE.
  const showHeadingsFunction = (e) => {
    setShowFullListOfHeadings(true);
  };

  const hideHeadingsFunction = (e) => {
    setShowFullListOfHeadings(false);
  };

  const hideImageAltTextsFunction = (e) => {
    setShowFullListOfImageAltTexts(false);
  };

  const showImageAltTextsFunction = (e) => {
    setShowFullListOfImageAltTexts(true);
  };

  const showFullListOfKeywordsFunction = (e) => {
    setShowFullListOfKeywords(true);
  };

  const hideFullListOfKeywordsFunction = (e) => {
    setShowFullListOfKeywords(false);
  };

  const showFullListOfInternalLinksFunction = (e) => {
    setShowFullListOfInternalLinks(true);
  };

  const hideFullListOfInternalLinksFunction = (e) => {
    setShowFullListOfInternalLinks(false);
  };

  const showFullListOfExternalLinksFunction = (e) => {
    setShowFullListOfExternalLinks(true);
  };

  const hideFullListOfExternalLinksFunction = (e) => {
    setShowFullListOfExternalLinks(false);
  };

  const showFullListOfOutgoingNoFollowLinksFunction = (e) => {
    setShowFullListOfOutgoingNoFollowLinks(true);
  };

  const hideFullListOfOutgoingNoFollowLinksFunction = (e) => {
    setShowFullListOfOutgoingNoFollowLinks(false);
  };

  const takeMetoSignUpFunction = () => {
    window.location.assign("/signup");
  };

  return (
    <div>
      <Transition.Root show={sidebarOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-40 md:hidden"
          onClose={setSidebarOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
          </Transition.Child>

          <div className="fixed inset-0 z-40 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>
                <div
                  style={{ cursor: "pointer" }}
                  className="flex flex-shrink-0 items-center px-4"
                >
                  <img
                    className="h-12 w-auto"
                    src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                    alt="SerpMaze"
                    onClick={takeMeToTheDashboardPage}
                  />
                </div>
                <div className="mt-5 h-0 flex-1 overflow-y-auto">
                  <nav className="space-y-1 px-2">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? "bg-gray-100 text-gray-900"
                            : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                          "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                        )}
                      >
                        <item.icon
                          className={classNames(
                            item.current
                              ? "text-gray-500"
                              : "text-gray-400 group-hover:text-gray-500",
                            "mr-3 flex-shrink-0 h-6 w-6"
                          )}
                          aria-hidden="true"
                        />
                        {item.name}
                      </a>
                    ))}
                    {/* <div className="space-y-1 mt-5">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "initial",
                          justifyContent: "space-between",
                          alignItems: "end",
                        }}
                      >
                        <h3
                          className="px-3 text-sm font-medium text-gray-500"
                          id="projects-headline"
                        >
                          Tracked sites
                        </h3>
                        <button
                          type="button"
                          className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                        >
                          <PlusSmallIcon
                            className="h-4 w-4"
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                      <div
                        className="space-y-1"
                        role="group"
                        aria-labelledby="projects-headline"
                      >
                        {secondaryNavigation.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                          >
                            <span className="truncate">{item.name}</span>
                          </a>
                        ))}
                      </div>
                    </div> */}
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
            <div className="w-14 flex-shrink-0" aria-hidden="true">
              {/* Dummy element to force sidebar to shrink to fit close icon */}
            </div>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop */}
      <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
        {/* Sidebar component, swap this element with another sidebar if you like */}
        <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
          <div
            style={{ cursor: "pointer" }}
            className="flex flex-shrink-0 items-center px-4"
          >
            <img
              className="h-12 w-auto"
              src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
              alt="SerpMaze"
              onClick={takeMeToTheDashboardPage}
            />
          </div>
          <div className="mt-5 flex flex-grow flex-col">
            <nav className="flex-1 space-y-1 px-2 pb-4">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-100 text-gray-900"
                      : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                    "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                  )}
                >
                  <item.icon
                    className={classNames(
                      item.current
                        ? "text-gray-500"
                        : "text-gray-400 group-hover:text-gray-500",
                      "mr-3 flex-shrink-0 h-6 w-6"
                    )}
                    aria-hidden="true"
                  />
                  {item.name}
                </a>
              ))}
              {/*  <div className="space-y-1 mt-5">
                <div
                  style={{
                    display: "flex",
                    flexDirection: "initial",
                    justifyContent: "space-between",
                    alignItems: "end",
                  }}
                >
                  <h3
                    className="px-3 text-sm font-medium text-gray-500"
                    id="projects-headline"
                  >
                    Tracked sites
                  </h3>
                  <button
                    type="button"
                    className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <PlusSmallIcon className="h-4 w-4" aria-hidden="true" />
                  </button>
                </div>
                <div
                  className="space-y-1"
                  role="group"
                  aria-labelledby="projects-headline"
                >
                  {secondaryNavigation.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                    >
                      <span className="truncate">{item.name}</span>
                    </a>
                  ))}
                </div>
              </div> */}
            </nav>
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col md:pl-64">
        <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
          <button
            type="button"
            className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <span className="sr-only">Open sidebar</span>
            <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
          </button>
          <div className="flex flex-1 justify-between px-4">
            <div className="flex flex-1">
              <form className="flex w-full md:ml-0" action="#" method="GET">
                <label htmlFor="search-field" className="sr-only">
                  Search
                </label>
                <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                  {/* <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center">
                      <MagnifyingGlassIcon
                        className="h-5 w-5"
                        aria-hidden="true"
                      />
                    </div> */}
                  <span
                  /*                     id="search-field"
                    className="block h-full w-full border-transparent py-2  pr-3 text-gray-900 placeholder-gray-500 focus:border-transparent focus:placeholder-gray-400 focus:outline-none focus:ring-0 sm:text-sm"
                    placeholder={email}
                    type="search"
                    name="search" */
                  />
                </div>
              </form>{" "}
            </div>
            <div className="ml-4 flex items-center md:ml-6">
              {/* Profile dropdown */}
              <Menu as="div" className="relative ml-3">
                <div>
                  <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                    <span className="sr-only">Open user menu</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                      />
                    </svg>
                  </Menu.Button>
                </div>
                <Transition
                  as={Fragment}
                  enter="transition ease-out duration-100"
                  enterFrom="transform opacity-0 scale-95"
                  enterTo="transform opacity-100 scale-100"
                  leave="transition ease-in duration-75"
                  leaveFrom="transform opacity-100 scale-100"
                  leaveTo="transform opacity-0 scale-95"
                >
                  <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                    {userNavigation.map((item) => (
                      <Menu.Item key={item.name}>
                        {({ active }) => (
                          <a
                            onClick={avatarOnClickFunction}
                            href={item.href}
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            {item.name}
                          </a>
                        )}
                      </Menu.Item>
                    ))}
                  </Menu.Items>
                </Transition>
              </Menu>
            </div>
          </div>
        </div>

        <main className="flex-1">
          <div className="py-6">
            {/* <div className="mx-auto max-w-7xl px-4 sm:px-6 md:px-8">
                <h1 className="text-2xl font-semibold text-gray-900">
                  Dashboard
                </h1>
              </div> */}
            <div className="">
              {" "}
              {/* mx-auto max-w-7xl px-4 sm:px-6 md:px-8 */}
              {/* Replace with your content */}
              {/*                 <div className="py-4">
                  <div className="h-96 rounded-lg border-4 border-dashed border-gray-200" />
                </div>
 */}
              {/* /End replace */}
              {overallLoading === true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Loading />
                </div>
              ) : (
                <Content>
                  <section className="general-layout ant-layout">
                    <main className="general-layout-content ant-layout-content">
                      {/* //THIS BELOW IS THE "ANALYSE DOMAIN" SEARCH INPUT FIELD! -**********************************/}
                      {firstTimeUser === false && (
                        <div className="ant-card analysis-form-card ant-card-bordered">
                          <div className="ant-card-body">
                            <Input
                              style={{ borderRadius: "4px" }}
                              size="large"
                              placeholder="Analyse site. eg. website.com"
                              className="ant-input-top-main"
                              prefix={<SearchOutlined />}
                              onChange={(e) =>
                                setQuicklyAnalyseInputField(e.target.value)
                              }
                            />
                            <Button
                              type="primary"
                              size="large"
                              style={{
                                borderRadius: "4px",
                                background: "#28A745",
                                border: "none",
                              }}
                              onClick={quicklyAnalyseInputFieldFunction}
                              className="analyse-domain-button"
                            >
                              <span>Analyse</span>
                            </Button>
                          </div>
                        </div>
                      )}

                      {/* // HERE I HAVE A CONDITIONAL RENDERING DEPENDING ON IF THIS IS A FIRST TIME USER OR NOT */}
                      {firstTimeUser === false ? (
                        <div className="outer-wrapper-for-body-content">
                          {/* <div className="ant-card-body"> */}

                          {/* THIS IS THE TOP "NAV" WHERE YOU CAN REMOVE THE SITE  */}
                          {/* <div
                      style={{
                        paddingLeft: "10px",
                        fontSize: "19px",
                        alignItems: "baseline",

                        display: "flex",
                        color: "#424747",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "baseline",
                          borderBottom: "3px solid #777B7C",
                        }}
                      >
                        <div
                          style={{
                            color: "#28A745",
                            display: "flex",
                            paddingRight: "0.5em",
                            alignItems: "center",
                            fontSize: "23px",
                          }}
                        >
                          <SettingOutlined />
                        </div>
                        <span
                          style={{
                            paddingBottom: "0.5em",
                          }}
                        >
                          {" "}
                          {trackedWebsite}
                        </span>

                        <div
                          style={{
                            color: "#424747",
                          }}
                        >
                          <Dropdown
                            overlay={dropdownMenuForSmallNavForTheWebsite}
                            placement="bottomRight"
                          >
                            <Button
                              style={{
                                lineHeight: "1.499",
                                position: "relative",
                                display: "flex",
                                justifyContent: "center",
                                fontWeight: "600",
                                borderRadius: "4px",
                                borderColor: "#d9d9d9",
                                color: "#777B7C",
                                height: "30px",
                                width: "30px",
                                textAlign: "center",
                                marginLeft: "8px",
                              }}
                            >
                              <DashOutlined />
                            </Button>
                          </Dropdown>
                        </div>
                      </div>
                    </div> */}
                          <AntdRow>
                            <AntdCol
                              xs={24}
                              xl={24} /* className="col-md-12 col-lg-4" */
                            >
                              {/* <div className="dashboard-seo-analysis-summary"> */}
                              {/* <div className="dashboard-seo-analysis-summary"> */}

                              <Card
                                title={
                                  <div className="card-title-body">
                                    <span className="card-title">
                                      {trackedWebsite}
                                    </span>
                                    <small>Your reports</small>
                                  </div>
                                }
                                extra={
                                  <div
                                  /*  className="card-link-div"
                              onClick={viewReportFromSummaryCardFunction} */
                                  >
                                    {/*                              View report <CaretRightOutlined /> */}
                                  </div>
                                }
                                style={{
                                  width: "100%",
                                }}
                              >
                                {Array.isArray(newDataSourceForTheTable) &&
                                newDataSourceForTheTable.length ? (
                                  <Table
                                    scroll={{ x: 500 }}
                                    pagination={{ pageSize: 15 }}
                                    dataSource={newDataSourceForTheTable}
                                    columns={columns}
                                  />
                                ) : (
                                  <div className="keywords-table">
                                    <AntdAlert
                                      message="You haven't added competitors yet. You do that from the Dashboard page."
                                      type="info"
                                      style={{
                                        borderRadius: "4px",
                                        color: "#000",
                                        fontWeight: "400",
                                      }}
                                    />
                                  </div>
                                )}

                                {errorInFetching === true && (
                                  <div>
                                    <small style={{ color: "red" }}>
                                      Sorry, something went wrong. 🙁
                                    </small>
                                    <br></br>
                                    <small style={{ color: "red" }}>
                                      Please try again at{" "}
                                      {timeReportWasGenerated} try again later.
                                    </small>
                                  </div>
                                )}

                                {browserTimedOut === true && (
                                  <div>
                                    <small style={{ color: "red" }}>
                                      Hmmmmm, <strong>{trackedWebsite}</strong>{" "}
                                      browser timed out. 🙁
                                    </small>
                                    <br></br>
                                    <small style={{ color: "red" }}>
                                      Browser timed out. The site might be down
                                      momentatily, or you might be on a slow
                                      connection. Please try again later.
                                    </small>
                                  </div>
                                )}
                              </Card>
                            </AntdCol>
                          </AntdRow>
                          {/* </div> */}
                          {/* <div className="ant-card-body"> */}

                          {/* </div> */}
                        </div>
                      ) : (
                        /* FIRST TIME USER === TRUE */
                        <Card
                          style={{
                            borderRadius: "4px",
                          }}
                          className="first-time-user-card ant-card"
                          title={
                            <div className="card-title-body">
                              <span className="card-title">
                                Welcome! Start by setting up your account
                              </span>
                              <small>
                                You need to set up your account first
                              </small>
                            </div>
                          }
                          extra={
                            <div className="view-report-and-add-competitors-div"></div>
                          }
                          style={{
                            width: "100%",
                          }}
                        >
                          <div>
                            <p>
                              To start improving your SEO, you need to set up
                              your account first.
                            </p>
                            <p>
                              Once you have set up your account, you will be
                              able to see your website's SEO performance right
                              here.
                            </p>
                            <div>
                              <span>
                                <button
                                  style={{
                                    background: "#28A745",
                                    borderRadius: "4px",
                                    border: "none",
                                  }}
                                  onClick={takeMeToTheDashboardPage}
                                  data-cy="add-new-tracked-website"
                                  type="button"
                                  className="ant-btn ant-btn-primary first-time-user-button"
                                  ant-click-animating-without-extra-node="false"
                                >
                                  <span>Take me to the dashboard page</span>
                                </button>
                              </span>
                            </div>
                          </div>
                        </Card>
                      )}
                      {/* //MODAL FOR THE DELETING OF A TRACKED SITE:  */}

                      <Modal
                        title="Are you sure?"
                        open={showDeleteModal}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        footer={[]}
                        /*  className="dashboard-edit-add-modal-outer-box"
                         */

                        className="modal-detete-button-outer-container"
                      >
                        <div
                          className="modal-delete-button-inner-container"
                          style={{
                            flexDirection: "row",
                            padding: "24px",
                          }}
                        >
                          <Button
                            style={{
                              width: "100%",
                              marginRigth: "12px",
                              backgroundColor: "#6c757d",
                              borderRadius: "0.25rem",
                              color: "white",
                              fontWeight: "400",
                              border: "none",
                              height: "2.8em",
                              fontSize: "1rem",
                            }}
                            className="modal-delete-button-no-button"
                            variant="secondary"
                            onClick={handleCancel}
                          >
                            No
                          </Button>
                          <Button
                            style={{
                              width: "100%",
                              fontSize: "1rem",
                              marginLeft: "12px",
                              backgroundColor: "#4aac48",
                              borderRadius: "0.25rem",
                              color: "white",
                              fontWeight: "400",
                              border: "none",
                              height: "2.8em",
                            }}
                            className="modal-delete-button-yes-button"
                            variant="success"
                            onClick={(event) => {
                              removeSiteFunction(event);
                            }}
                          >
                            Yes
                          </Button>
                        </div>
                      </Modal>

                      {/* //THE QUICK REPORT MODAL */}

                      <Modal
                        title="Report"
                        open={isQuickReportModalOpen}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        footer={[]}
                        width={1000}
                        /*  className="dashboard-edit-add-modal-outer-box"
                         */

                        className="modal-detete-button-outer-container"
                      >
                        <Content>
                          <Container fluid className="">
                            {" "}
                            {/* BEFORE I HAD ADDED "mt-5 mb-5" HERE */}
                            <Helmet>
                              <meta charSet="utf-8" />
                              <title>SerpMaze.com | Onsite SEO checker</title>
                              <meta
                                name="description"
                                content="Check your onsite SEO in seconds. Get a step-by-step plan on how to improve your SEO."
                              />
                              <meta name="theme-color" content="#008f68" />

                              <style>
                                {
                                  "body { background: linear-gradient(180deg, #264068 100%, #50678b 100%) }"
                                }
                              </style>

                              <meta name="twitter:card" content="summary" />
                              {/*         <meta name="twitter:site" content="@nytimesbits" />
        <meta name="twitter:creator" content="@nickbilton" /> */}
                              <meta
                                property="og:url"
                                content="https://serpmaze.com/"
                              />
                              <meta
                                property="og:title"
                                content="SerpMaze.com | Onsite SEO checker"
                              />
                              <meta
                                property="og:description"
                                content="Check your onsite SEO in seconds. Get a step-by-step plan on how to improve your SEO."
                              />
                              {/*         <meta
          property="og:image"
          content="http://graphics8.nytimes.com/images/2011/12/08/technology/bits-newtwitter/bits-newtwitter-tmagArticle.jpg"
        /> */}
                            </Helmet>
                            <Row>
                              <Col
                                className="results-col-onsite-scraping-results-component"
                                style={{ padding: "24px" }}
                              >
                                {firstTimeUser === true ? (
                                  <Card
                                    style={{
                                      borderRadius: "4px",
                                    }}
                                    className="first-time-user-card ant-card"
                                    title={
                                      <div className="card-title-body">
                                        <span className="card-title">
                                          Welcome! Start by setting up your
                                          account
                                        </span>
                                        <small>
                                          You need to set up your account first
                                        </small>
                                      </div>
                                    }
                                    extra={
                                      <div className="view-report-and-add-competitors-div"></div>
                                    }
                                    style={{
                                      width: "100%",
                                    }}
                                  >
                                    <div>
                                      <p>
                                        To start improving your SEO, you need to
                                        set up your account first.
                                      </p>
                                      <p>
                                        Once you have set up your account, you
                                        will be able to see your website's SEO
                                        performance right here.
                                      </p>
                                      <div>
                                        <span>
                                          <button
                                            style={{
                                              background: "#28A745",
                                              borderRadius: "4px",
                                              border: "none",
                                            }}
                                            onClick={takeMeToTheDashboardPage}
                                            data-cy="add-new-tracked-website"
                                            type="button"
                                            className="ant-btn ant-btn-primary first-time-user-button"
                                            ant-click-animating-without-extra-node="false"
                                          >
                                            <span>
                                              Take me to the dashboard page
                                            </span>
                                          </button>
                                        </span>
                                      </div>
                                    </div>
                                  </Card>
                                ) : (
                                  <div className="wrapper-for-the-main-report-section">
                                    {/* //OVERALL SEO CARD SECTION ****************************************************************/}

                                    <div
                                      className="d-flex common-seo-issues-outer-div"
                                      style={{ background: "white" }}
                                    >
                                      <div className="top-card-box-onsite-result-component">
                                        <h1
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          {urlInput}
                                        </h1>
                                        <p
                                          style={{
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          }}
                                        >
                                          Report generated on{" "}
                                          {timeRightNowForReport}
                                        </p>
                                      </div>
                                      <div className="summary-graph">
                                        {/* PIE CHART BELOW *************************************************/}

                                        <div className="summary-graph-wrapper">
                                          <div className="summary-graph-total">
                                            <PieChart
                                              data={[
                                                {
                                                  value: overallSEOScore,
                                                  color:
                                                    overallSEOScore >= 70
                                                      ? "#28A745"
                                                      : overallSEOScore >= 50 &&
                                                        overallSEOScore <= 69
                                                      ? "#FFC107"
                                                      : "#DC3545",
                                                },
                                              ]}
                                              totalValue={100}
                                              lineWidth={20}
                                              label={({ dataEntry }) =>
                                                dataEntry.value + "/100"
                                              }
                                              labelStyle={{
                                                fontSize: "12px",
                                                fontFamily: "sans-serif",
                                                fill:
                                                  overallSEOScore >= 70
                                                    ? "#28A745"
                                                    : overallSEOScore >= 50 &&
                                                      overallSEOScore <= 69
                                                    ? "#FFC107"
                                                    : "#DC3545",
                                              }}
                                              labelPosition={0}
                                              startAngle={270}
                                            />
                                          </div>
                                          {/* // HIDING THE "IMPROVE YOUR SCORE NOW " BUTTON ON THIS REPORT PAGE */}
                                          {/* <div className="register-modal">
                          <Button
                            onClick={takeMetoSignUpFunction}
                            variant="outline-danger"
                            size="lg"
                          >
                            <span>
                              Improve your score now{" "}
                              <i className="bi bi-arrow-up-right"></i>
                            </span>
                          </Button>
                        </div> */}
                                        </div>
                                        <div className="summary-graph-split">
                                          <div className="progress-item failed">
                                            <span className="progress-label">
                                              <strong>
                                                {numberOfFailedTests}{" "}
                                              </strong>
                                              Failed
                                            </span>
                                            <div className="ant-progress-outer">
                                              <ProgressBar
                                                className="ant-progress-inner"
                                                striped
                                                variant="danger"
                                                now={
                                                  (100 / 8) *
                                                  numberOfFailedTests
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="progress-item warning">
                                            <span className="progress-label">
                                              <strong>
                                                {numberOfWarningTests}{" "}
                                              </strong>
                                              Warnings
                                            </span>
                                            <div className="ant-progress-outer">
                                              <ProgressBar
                                                className="ant-progress-inner"
                                                striped
                                                variant="warning"
                                                now={
                                                  (100 / 8) *
                                                  numberOfWarningTests
                                                }
                                              />
                                            </div>
                                          </div>
                                          <div className="progress-item passed">
                                            <span className="progress-label">
                                              <strong>
                                                {numberOfSuccessTests}{" "}
                                              </strong>
                                              Passed
                                            </span>
                                            <div className="ant-progress-outer">
                                              <ProgressBar
                                                className="ant-progress-inner"
                                                striped
                                                variant="success"
                                                now={
                                                  (100 / 8) *
                                                  numberOfSuccessTests
                                                }
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* //COMMON SEO ISSUES ****************************************************************/}
                                    <div
                                      className="d-flex common-seo-issues-outer-div mt-3"
                                      style={{ background: "white" }}
                                    >
                                      <div className="top-card-box-onsite-result-component">
                                        <h4>Common SEO issues</h4>
                                      </div>
                                      <div className="common-seo-issues-inner-div">
                                        {/*               <div className="title-div-and-middlemiddle-results-div"> */}

                                        <div className="title-div-onsite-result-component">
                                          {metaTitle?.length >= 30 &&
                                          metaTitle?.length <= 65 ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Meta title test{" "}
                                                </strong>
                                                <small>
                                                  Site passed meta title test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Meta title test{" "}
                                                </strong>
                                                <small>
                                                  Site did not pass meta title
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  Meta titles are bits of HTML
                                                  code in the header of a
                                                  website. Having them, help
                                                  search engines understand what
                                                  the content of the page is
                                                  about. Pages' titles are
                                                  usually shown whenever a page
                                                  appears in search engine
                                                  results.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {metaTitle?.length > 1 ? (
                                              <small>
                                                This webpage is using a meta
                                                title tag{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage is not using a meta
                                                title tag{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>Title: </strong>
                                              <span
                                                style={{ fontSize: "14px" }}
                                              >
                                                {metaTitle}
                                              </span>
                                            </div>
                                            <div style={{ display: "flex" }}>
                                              <strong>Length:&nbsp;</strong>{" "}
                                              <p style={{ margin: "0" }}>
                                                {metaTitle?.length} characters
                                              </p>
                                            </div>
                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {metaTitle?.length <= 30 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  Your meta title is too short.
                                                  Recommended 30-65 characters.
                                                </Alert>
                                              ) : metaTitle?.length >= 65 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  Your meta title is too long.
                                                  Recommended is 30-65
                                                  characters.
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  Your meta title is between 30
                                                  - 65 characters which is the
                                                  recommended length. Good job
                                                  💪
                                                </Alert>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                Meta titles are bits of HTML
                                                code in the header of a website.
                                                Having them, help search engines
                                                understand what the content of
                                                the page is about. Pages' titles
                                                are usually shown whenever a
                                                page appears in search engine
                                                results.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* META DESCRIPTION : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        {/*               <div className="title-div-and-middlemiddle-results-div"> */}
                                        <div className="title-div-onsite-result-component">
                                          {metaDescription?.length >= 120 &&
                                          metaDescription?.length <= 160 ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Meta description test{" "}
                                                </strong>
                                                <small>
                                                  Site passed meta description
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Meta description test{" "}
                                                </strong>
                                                <small>
                                                  Site did not pass meta
                                                  description test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  Meta descriptions are bits of
                                                  HTML code in the header of a
                                                  website. Having them, help
                                                  search engines understand what
                                                  the content of the page is
                                                  about. Pages' meta
                                                  descriptions are usually shown
                                                  whenever a page appears in
                                                  search engine results.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {metaDescription?.length > 1 ? (
                                              <small>
                                                This webpage is using a meta
                                                description tag{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage is not using a meta
                                                description tag{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>Description: </strong>
                                              <span
                                                style={{ fontSize: "14px" }}
                                              >
                                                {metaDescription}
                                              </span>
                                            </div>

                                            <div style={{ display: "flex" }}>
                                              <strong>Length:&nbsp;</strong>{" "}
                                              <p style={{ margin: "0" }}>
                                                {metaDescription?.length}{" "}
                                                characters
                                              </p>
                                            </div>
                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {metaDescription?.length <=
                                              120 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  Your meta description is too
                                                  short. Recommended 120-160
                                                  characters.
                                                </Alert>
                                              ) : metaDescription?.length >=
                                                160 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  Your meta description is too
                                                  long. Recommended is 120-160
                                                  characters.
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  Your meta description is
                                                  between 120 - 160 characters
                                                  which is the recommended
                                                  length. Good job 💪
                                                </Alert>
                                              )}
                                            </div>
                                          </div>
                                        </div>

                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                Meta descriptions are bits of
                                                HTML code in the header of a
                                                website. Having them, help
                                                search engines understand what
                                                the content of the page is
                                                about. Pages' meta descriptions
                                                are usually shown whenever a
                                                page appears in search engine
                                                results.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* GOOGLE RESULTS PREVIEW TEST : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        {/*               <div className="title-div-and-middlemiddle-results-div"> */}
                                        <div className="title-div-onsite-result-component">
                                          <div className="flag-and-title-div-onsite-result-component">
                                            {" "}
                                            <i
                                              style={{
                                                color: "#808080",
                                                fontSize: "1.5em",
                                                paddingRight: "0.5em",
                                              }}
                                              className="bi bi-signpost-2-fill"
                                            ></i>
                                            <div className="meta-title-test-and-overall-recommendation-div">
                                              <strong>
                                                Google Search Results Preview
                                                Test
                                              </strong>
                                              {/* <small>Site passed meta description test</small> */}
                                            </div>
                                          </div>

                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  This is how your page most
                                                  likely will look like in a
                                                  Google search result. Most of
                                                  the time Google will display
                                                  your meta title and meta
                                                  description in a result. If
                                                  these elements are too long,
                                                  Google will shorten them.
                                                  Titles are recommended to be
                                                  up to 65 characters in length
                                                  and descriptions up to 160
                                                  characters in length.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div desktop-text">
                                            <small>Desktop version: </small>
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div className="google-search-preview desktop">
                                              <span className="url-format">
                                                {"https://" + urlInput}
                                              </span>
                                              <span className="title-format line-clamp lines1">
                                                {metaTitle}
                                              </span>
                                              <span className="description-format line-clamp lines2">
                                                {metaDescription}
                                              </span>
                                            </div>
                                          </div>
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            <small>Mobile version: </small>
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div className="google-search-preview mobile">
                                              <span className="url-format">
                                                {"https://" + urlInput}
                                              </span>
                                              <span className="title-format line-clamp lines1">
                                                {metaTitle}
                                              </span>
                                              <span className="description-format line-clamp lines2">
                                                {metaDescription}
                                              </span>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                This is how your page most
                                                likely will look like in a
                                                Google search result. Most of
                                                the time Google will display
                                                your meta title and meta
                                                description in a result. If
                                                these elements are too long,
                                                Google will shorten them. Titles
                                                are recommended to be up to 65
                                                characters in length and
                                                descriptions up to 160
                                                characters in length.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* H-TAGS  : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          {h1Length === 1 ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Heading tags test{" "}
                                                </strong>
                                                <small>
                                                  Site passed headings test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Heading tags test{" "}
                                                </strong>
                                                <small>
                                                  Site did not pass headings
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  HTML heading tags are used to
                                                  format headings on your page
                                                  in order of importance. There
                                                  are six different HTML heading
                                                  tags, from H1 to H6. They go
                                                  from most important to least
                                                  important, with the size of
                                                  the text generally decreasing
                                                  in size with the importance.
                                                  The H1 tag is the one that
                                                  comes first and shows search
                                                  engines what content can be
                                                  expected on the rest of the
                                                  page. H1 tags play an
                                                  important role in SEO. All of
                                                  the important pages on your
                                                  site should have H1 tags to
                                                  draw in the reader and give a
                                                  clear indication of the
                                                  content on the page. Try to
                                                  only have one H1 per page, to
                                                  not confuse search engines.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {h1Length === 1 ? (
                                              <small>
                                                This webpage has the right
                                                amount of H1 tags{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : h1Length < 1 ? (
                                              <small>
                                                This webpage does not have a H1
                                                tag{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage has too many H1
                                                tags{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>H1 tags: </strong>
                                              <span
                                                style={{ fontSize: "14px" }}
                                              >
                                                This webpage has{" "}
                                                <strong> {h1Length}</strong> H1
                                                tags
                                              </span>
                                            </div>

                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {h1Length < 1 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  You do not have a H1 tag. It
                                                  is recommended to have 1 H1
                                                  tag on each page.
                                                </Alert>
                                              ) : h1Length > 1 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  You have too many H1 tags. It
                                                  is best to just have 1 H1 tag
                                                  on each page.
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  You have 1 H1 tag which is the
                                                  recommeded amount. Good job 💪
                                                </Alert>
                                              )}
                                              <div>
                                                <strong>H2 tags: </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  This webpage has{" "}
                                                  <strong> {h2Length}</strong>{" "}
                                                  H2 tags
                                                </span>
                                              </div>
                                              <div>
                                                <strong>H3 tags: </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  This webpage has{" "}
                                                  <strong> {h3Length}</strong>{" "}
                                                  H3 tags
                                                </span>
                                              </div>
                                              <div>
                                                <strong>H4 tags: </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  This webpage has{" "}
                                                  <strong> {h4Length}</strong>{" "}
                                                  H4 tags
                                                </span>
                                              </div>
                                              <div>
                                                <strong>H5 tags: </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  This webpage has{" "}
                                                  <strong> {h5Length}</strong>{" "}
                                                  H5 tags
                                                </span>
                                              </div>
                                              <div>
                                                <strong>H6 tags: </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  This webpage has{" "}
                                                  <strong> {h6Length}</strong>{" "}
                                                  H6 tags
                                                </span>
                                              </div>

                                              {showFullListOfHeadings ===
                                              false ? (
                                                <div
                                                  style={{ maxWidth: "450px" }}
                                                  className="mt-4"
                                                  onClick={showHeadingsFunction}
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Show the whole list of
                                                    headings in chronological
                                                    order
                                                  </span>
                                                </div>
                                              ) : (
                                                <div
                                                  className="mt-4"
                                                  onClick={hideHeadingsFunction}
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Hide the whole list of
                                                    headings
                                                  </span>
                                                </div>
                                              )}
                                              {showFullListOfHeadings ===
                                              true ? (
                                                <div
                                                  className="pt-4"
                                                  style={{ maxWidth: "450px" }}
                                                >
                                                  <strong>
                                                    These are all your H-tags in
                                                    chronological order:{" "}
                                                  </strong>
                                                  <span
                                                    style={{ fontSize: "14px" }}
                                                  >
                                                    {arrayWithAllHInformation?.map(
                                                      (e, index) => {
                                                        return (
                                                          <p key={index}>{e}</p>
                                                        );
                                                      }
                                                    )}
                                                  </span>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                HTML heading tags are used to
                                                format headings on your page in
                                                order of importance. There are
                                                six different HTML heading tags,
                                                from H1 to H6. They go from most
                                                important to least important,
                                                with the size of the text
                                                generally decreasing in size
                                                with the importance. The H1 tag
                                                is the one that comes first and
                                                shows search engines what
                                                content can be expected on the
                                                rest of the page. H1 tags play
                                                an important role in SEO. All of
                                                the important pages on your site
                                                should have H1 tags to draw in
                                                the reader and give a clear
                                                indication of the content on the
                                                page. Try to only have one H1
                                                per page, to not confuse search
                                                engines.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* IMAGE ALT TAGS  : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          {numberOfEmptyAltTexts < 1 ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Image Alt text test{" "}
                                                </strong>
                                                <small>
                                                  Site passed image Alt text
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          ) : numberOfEmptyAltTexts < 5 ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#a1a102",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Image Alt text test{" "}
                                                </strong>
                                                <small>
                                                  Site has some small issues
                                                  regarding image Alt texts
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Image Alt text test{" "}
                                                </strong>
                                                <small>
                                                  Site did not pass the image
                                                  Alt texts test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  Alt texts are text
                                                  alternatives to images when a
                                                  browser can’t properly render
                                                  them or to help visually
                                                  impaired people know what the
                                                  image shows. Similar to the
                                                  title, the alt attribute is
                                                  used to describe the contents
                                                  of an image file. Adding
                                                  appropriate alt texts to the
                                                  images on your website can
                                                  help your website achieve
                                                  better rankings in the search
                                                  engines by associating
                                                  keywords with images. It
                                                  provides Google with useful
                                                  information about the subject
                                                  matter of the image.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {numberOfEmptyAltTexts === 0 ? (
                                              <small>
                                                This webpage has 0 missing Alt
                                                texts{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage has missing Alt
                                                texts{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>
                                                Missing Alt texts:{" "}
                                              </strong>
                                              <span
                                                style={{ fontSize: "14px" }}
                                              >
                                                <strong>
                                                  {" "}
                                                  {numberOfEmptyAltTexts}
                                                </strong>
                                              </span>
                                            </div>

                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {numberOfEmptyAltTexts >= 1 ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  The webpage has{" "}
                                                  {numberOfEmptyAltTexts}{" "}
                                                  missing Alt texts. It is best
                                                  not to have any missing Alt
                                                  texts.
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  The webpage has 0 missing Alt
                                                  texts. Good job 💪
                                                </Alert>
                                              )}

                                              {showFullListOfImageAltTexts ===
                                              false ? (
                                                <div
                                                  style={{ maxWidth: "450px" }}
                                                  className="mt-4"
                                                  onClick={
                                                    showImageAltTextsFunction
                                                  }
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Show the whole list of image
                                                    Alt texts in chronological
                                                    order
                                                  </span>
                                                </div>
                                              ) : (
                                                <div
                                                  className="mt-4"
                                                  onClick={
                                                    hideImageAltTextsFunction
                                                  }
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Hide the whole list of image
                                                    Alt texts
                                                  </span>
                                                </div>
                                              )}
                                              {showFullListOfImageAltTexts ===
                                              true ? (
                                                <div
                                                  className="pt-4"
                                                  style={{ maxWidth: "450px" }}
                                                >
                                                  <strong>
                                                    These are all your image Alt
                                                    texts in chronological
                                                    order:{" "}
                                                  </strong>
                                                  <span
                                                    style={{ fontSize: "14px" }}
                                                  >
                                                    {imageSrcAndAltTexts?.map(
                                                      (e, index) => {
                                                        return (
                                                          <div
                                                            className="mt-3"
                                                            key={index}
                                                          >
                                                            <strong>
                                                              Image {index + 1}:
                                                            </strong>
                                                            <br /> Image source:{" "}
                                                            <a
                                                              target="_blank"
                                                              href={`${e.imageSrc}`}
                                                            >
                                                              {e.imageSrc.slice(
                                                                0,
                                                                34
                                                              ) + "..."}
                                                            </a>
                                                            <p>
                                                              Image Alt text:{" "}
                                                              {e.altText
                                                                .length > 1 ? (
                                                                <span>
                                                                  {" "}
                                                                  {
                                                                    e.altText
                                                                  }{" "}
                                                                </span>
                                                              ) : (
                                                                <span
                                                                  style={{
                                                                    color:
                                                                      "red",
                                                                  }}
                                                                >
                                                                  Alt text
                                                                  missing
                                                                </span>
                                                              )}{" "}
                                                              {/* {e.altText} */}
                                                            </p>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                  </span>
                                                </div>
                                              ) : (
                                                <></>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                Alt texts are text alternatives
                                                to images when a browser can’t
                                                properly render them or to help
                                                visually impaired people know
                                                what the image shows. Similar to
                                                the title, the alt attribute is
                                                used to describe the contents of
                                                an image file. Adding
                                                appropriate alt texts to the
                                                images on your website can help
                                                your website achieve better
                                                rankings in the search engines
                                                by associating keywords with
                                                images. It provides Google with
                                                useful information about the
                                                subject matter of the image.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* ROBOTS.TXT FILE COMING BELOW HERE  : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          {robotsTXTExists === true ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Robots.txt test{" "}
                                                </strong>
                                                <small>
                                                  Site passed Robots.txt test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>
                                                  Robots.txt test{" "}
                                                </strong>
                                                <small>
                                                  Site did not pass Robots.txt
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  Robots.txt is a text file
                                                  webmasters create to instruct
                                                  search engine robots how to
                                                  crawl their website. In
                                                  practice, robots.txt files
                                                  indicate your "crawl
                                                  instructions" to search engine
                                                  robots. These crawl
                                                  instructions are specified by
                                                  “disallowing” or “allowing”
                                                  the behaviour of certain (or
                                                  all) crawlers.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {robotsTXTExists === true ? (
                                              <small>
                                                This webpage has a Robots.txt
                                                file{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage is missing a
                                                Robots.txt file{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            {robotsTXTExists === true ? (
                                              <div>
                                                <strong>
                                                  Robots.txt file:{" "}
                                                </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  <strong>
                                                    <a
                                                      target="_blank"
                                                      href={`${
                                                        "https://" +
                                                        urlInput +
                                                        "/robots.txt"
                                                      }`}
                                                    >
                                                      {urlInput + "/robots.txt"}
                                                    </a>{" "}
                                                  </strong>
                                                </span>
                                              </div>
                                            ) : (
                                              <div>
                                                <strong>
                                                  No Robots.txt file found{" "}
                                                </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                ></span>
                                              </div>
                                            )}

                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {robotsTXTExists === false ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  The webpage is missing a
                                                  Robots.txt file. It is alwasy
                                                  best to have one. You can read
                                                  about what a Robots.txt file
                                                  is{" "}
                                                  {
                                                    <a href="https://developers.google.com/search/docs/advanced/robots/robots_txt">
                                                      here.
                                                    </a>
                                                  }
                                                  .
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  The webpage has a Robots.txt
                                                  file. Good job 💪
                                                </Alert>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                Robots.txt is a text file
                                                webmasters create to instruct
                                                search engine robots how to
                                                crawl their website. In
                                                practice, robots.txt files
                                                indicate your "crawl
                                                instructions" to search engine
                                                robots. These crawl instructions
                                                are specified by “disallowing”
                                                or “allowing” the behaviour of
                                                certain (or all) crawlers.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* FAVICON TEST COMING BELOW HERE  : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          {faviconFromWebsite?.length > 1 ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>Favicon test </strong>
                                                <small>
                                                  Site passed favicon test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>Favicon test </strong>
                                                <small>
                                                  Site did not pass favicon test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  A favicon is a small icon
                                                  associated with a website.
                                                  Favicons are used in browser
                                                  tabs, browser history, toolbar
                                                  apps, bookmarks dropdown,
                                                  search bar, and search bar
                                                  recommendations. Having a
                                                  favicon helps with branding
                                                  your site and makes it easy
                                                  for your users to remember and
                                                  to navigate to your site.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {faviconFromWebsite?.length > 1 ? (
                                              <small>
                                                This webpage has a favicon{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage is missing a
                                                favicon{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            {faviconFromWebsite?.length > 1 ? (
                                              <div>
                                                <strong>Favicon: </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  <strong>
                                                    <a
                                                      target="_blank"
                                                      href={`${faviconFromWebsite}`}
                                                    >
                                                      {faviconFromWebsite}
                                                    </a>{" "}
                                                  </strong>
                                                </span>
                                              </div>
                                            ) : (
                                              <div>
                                                <strong>
                                                  No favicon found{" "}
                                                </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                ></span>
                                              </div>
                                            )}

                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {faviconFromWebsite ===
                                              undefined ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  The webpage is missing a
                                                  favicon. It is alwasy best to
                                                  have a favicon. You should add
                                                  one.
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  The webpage has a favicon.
                                                  Good job 💪
                                                </Alert>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                A favicon is a small icon
                                                associated with a website.
                                                Favicons are used in browser
                                                tabs, browser history, toolbar
                                                apps, bookmarks dropdown, search
                                                bar, and search bar
                                                recommendations. Having a
                                                favicon helps with branding your
                                                site and makes it easy for your
                                                users to remember and to
                                                navigate to your site.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* MOST COMMON USED KEYWORDS BELOW HERE : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          <div className="flag-and-title-div-onsite-result-component">
                                            {" "}
                                            <i
                                              style={{
                                                color: "#808080",
                                                fontSize: "1.5em",
                                                paddingRight: "0.5em",
                                              }}
                                              className="bi bi-sort-down"
                                            ></i>
                                            <div className="meta-title-test-and-overall-recommendation-div">
                                              <strong>
                                                Most common used keywords{" "}
                                              </strong>
                                              {/* <small>Site passed favicon test</small> */}
                                            </div>
                                          </div>

                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  This is showing the most
                                                  common used keywords on this
                                                  page and the number of times
                                                  it is used. Crawlers migth
                                                  associate these keywords with
                                                  your website.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            <small>
                                              These are the keywords that appear
                                              on the site the most. This can be
                                              useful, as search engine
                                              algorithms use these to determine
                                              what the topic of your page is
                                              about.{" "}
                                              {/* <i
                          style={{ color: "#4aac48" }}
                          className="bi bi-hand-thumbs-up"
                        ></i> */}
                                            </small>
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>
                                                Top 10 most used keywords:{" "}
                                              </strong>
                                              <div className="mb-2"></div>
                                              {/* <span style={{ fontSize: "14px" }}>
                                               */}
                                              {mostCommonKeywords
                                                ?.slice(0, 10)
                                                .map((e, index) => (
                                                  <div key={index}>
                                                    <Badge pill variant="light">
                                                      {" "}
                                                      <Badge variant="secondary">
                                                        {e[1]}
                                                      </Badge>{" "}
                                                      {e[0]}
                                                    </Badge>
                                                  </div>
                                                ))}
                                            </div>

                                            {showFullListOfKeywords ===
                                            false ? (
                                              <div>
                                                <div
                                                  style={{ maxWidth: "450px" }}
                                                  className="mt-4"
                                                  onClick={
                                                    showFullListOfKeywordsFunction
                                                  }
                                                >
                                                  <span
                                                    style={{
                                                      fontSize: "14px",
                                                      textDecoration:
                                                        "underline",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    Show the whole list of
                                                    keywords
                                                  </span>
                                                </div>
                                                {/* //HIDING THE "TRACK YOUR KEYWORDS NOW" PROMO ON THIS REPORT PAGE  */}
                                                {/*  <div className="promo-content mt-4">
                                <h6>Start tracking your keywords</h6>
                                <p>
                                  Would you like to know what your ranking on
                                  Google is for these keywords on a daily basis?
                                </p>
                                <p>
                                  Just sign up for our free trial and start
                                  using our keyword tracker.
                                </p>
                                <div class="sign-up-now-button-div">
                                  <Button
                                    type="button"
                                    variant="success"
                                    class="track-your-keywords-now-button"
                                    size="lg"
                                    onClick={takeMetoSignUpFunction}
                                  >
                                    <span>
                                      START TRACKING{" "}
                                      <i class="bi bi-lightning-charge"></i>
                                    </span>
                                  </Button>
                                </div>
                              </div> */}
                                              </div>
                                            ) : (
                                              <div
                                                className="mt-4"
                                                onClick={
                                                  hideFullListOfKeywordsFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Hide the whole list of
                                                  keywords
                                                </span>
                                              </div>
                                            )}
                                            {showFullListOfKeywords === true ? (
                                              <div
                                                className="pt-4"
                                                style={{ maxWidth: "450px" }}
                                              >
                                                <strong>
                                                  These are all the keywords:{" "}
                                                </strong>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  {mostCommonKeywords?.map(
                                                    (e, index) => (
                                                      <div
                                                        key={index}
                                                        className={e.index}
                                                      >
                                                        <Badge
                                                          pill
                                                          variant="light"
                                                        >
                                                          {" "}
                                                          <Badge variant="secondary">
                                                            {e[1]}
                                                          </Badge>{" "}
                                                          {e[0]}
                                                        </Badge>
                                                      </div>
                                                    )
                                                  )}

                                                  {/* {imageSrcAndAltTexts?.map((e, index) => {
                            return (
                              <div className="mt-3" key={index}>
                                <strong>Image {index + 1}:</strong>
                                <br /> Image source:{" "}
                                <a target="_blank" href={`${e.imageSrc}`}>
                                  {e.imageSrc.slice(0, 34) + "..."}
                                </a>
                                <p>
                                  Image Alt text:{" "}
                                  {e.altText.length > 1 ? (
                                    <span> {e.altText} </span>
                                  ) : (
                                    <span style={{ color: "red" }}>
                                      Alt text missing
                                    </span>
                                  )}{" "}

                                </p>
                              </div>
                            );
                          })} */}
                                                </span>
                                              </div>
                                            ) : (
                                              <></>
                                            )}

                                            <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                This is showing the most common
                                                used keywords on this page and
                                                the number of times it is used.
                                                Crawlers migth associate these
                                                keywords with your website.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* INTERNAL LINKS SECTION : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          <div className="flag-and-title-div-onsite-result-component">
                                            {" "}
                                            <i
                                              style={{
                                                color: "#808080",
                                                fontSize: "1.5em",
                                                paddingRight: "0.5em",
                                              }}
                                              className="bi bi-link-45deg"
                                            ></i>
                                            <div className="meta-title-test-and-overall-recommendation-div">
                                              <strong>Internal links </strong>
                                              {/* <small>Site passed favicon test</small> */}
                                            </div>
                                          </div>

                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  When a link is linking from
                                                  one page to another page
                                                  within the same web site it is
                                                  called an "internal link".
                                                  Google analyses internal links
                                                  to understand the most
                                                  important pages on a website.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            <small>
                                              These are the most linked to
                                              internal pages on this web page.
                                              Search engines analyses internal
                                              links to understand the most
                                              important pages on a website.
                                              {/* <i
            style={{ color: "#4aac48" }}
            className="bi bi-hand-thumbs-up"
          ></i> */}
                                            </small>
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>
                                                Top 5 internal links:{" "}
                                              </strong>
                                              <div className="mb-2"></div>

                                              {/* <span style={{ fontSize: "14px" }}>
                                               */}
                                              {internalLinks
                                                ?.slice(0, 5)
                                                .map((e, index) => (
                                                  <div
                                                    key={index}
                                                    className="internal-and-external-links-outer-div"
                                                  >
                                                    <div>
                                                      <Badge
                                                        pill
                                                        variant="secondary"
                                                        className="badge-for-external-and-internal-links"
                                                      >
                                                        {" "}
                                                        {e[1]}
                                                        {/*                             <Badge variant="secondary"> </Badge> */}
                                                        {/* {e[0].length >= 40
                              ? " " + e[0].slice(0, 40) + "..."
                              : " " + e[0]} */}{" "}
                                                      </Badge>
                                                    </div>
                                                    <div className="ml-2">
                                                      <small>
                                                        <a
                                                          target="_blank"
                                                          href={e[0]}
                                                        >
                                                          {e[0]}
                                                        </a>{" "}
                                                      </small>
                                                    </div>
                                                  </div>
                                                ))}
                                            </div>

                                            {showFullListOfInternalLinks ===
                                            false ? (
                                              <div
                                                style={{ maxWidth: "450px" }}
                                                className="mt-4"
                                                onClick={
                                                  showFullListOfInternalLinksFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Show the whole list of
                                                  internal links
                                                </span>
                                              </div>
                                            ) : (
                                              <div
                                                className="mt-4"
                                                onClick={
                                                  hideFullListOfInternalLinksFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Hide the whole list of
                                                  internal links
                                                </span>
                                              </div>
                                            )}
                                            {showFullListOfInternalLinks ===
                                            true ? (
                                              <div
                                                className="pt-4"
                                                style={{ maxWidth: "450px" }}
                                              >
                                                <strong>
                                                  These are all the internal
                                                  links:{" "}
                                                </strong>
                                                <div className="mb-2"></div>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  {internalLinks?.map(
                                                    (e, index) => (
                                                      <div
                                                        key={index}
                                                        className="internal-and-external-links-outer-div"
                                                      >
                                                        <div
                                                          className={e.index}
                                                        >
                                                          <Badge
                                                            pill
                                                            variant="secondary"
                                                            className="badge-for-external-and-internal-links"
                                                          >
                                                            {" "}
                                                            {e[1]}
                                                            {/*                             <Badge variant="secondary"> </Badge> */}
                                                            {/* {e[0].length >= 40
                              ? " " + e[0].slice(0, 40) + "..."
                              : " " + e[0]} */}{" "}
                                                          </Badge>
                                                        </div>
                                                        <div className="ml-2">
                                                          <small>
                                                            <a
                                                              target="_blank"
                                                              href={e[0]}
                                                            >
                                                              {e[0]}
                                                            </a>{" "}
                                                          </small>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </span>
                                              </div>
                                            ) : (
                                              <></>
                                            )}

                                            <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                When a link is linking from one
                                                page to another page within the
                                                same web site it is called an
                                                "internal link". Google analyses
                                                internal links to understand the
                                                most important pages on a
                                                website.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* EXTERNAL LINKS SECTION : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          <div className="flag-and-title-div-onsite-result-component">
                                            {" "}
                                            <i
                                              style={{
                                                color: "#808080",
                                                fontSize: "1.5em",
                                                paddingRight: "0.5em",
                                              }}
                                              className="bi bi-box-arrow-up-right"
                                            ></i>
                                            <div className="meta-title-test-and-overall-recommendation-div">
                                              <strong>Outgoing links </strong>
                                              {/* <small>Site passed favicon test</small> */}
                                            </div>
                                          </div>

                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  When a link is pointing to a
                                                  domain that is different from
                                                  the domain from where the link
                                                  exists on, it is called an
                                                  "external link". External
                                                  links have impact on search
                                                  engine rankings as they are
                                                  seen as a vote of confidence.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            <small>
                                              These are the pages that are being
                                              linked to the most.
                                              {/* <i
style={{ color: "#4aac48" }}
className="bi bi-hand-thumbs-up"
></i> */}
                                            </small>
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>
                                                Top 5 outgoing links:{" "}
                                              </strong>
                                              <div className="mb-2"></div>

                                              {/* <span style={{ fontSize: "14px" }}>
                                               */}
                                              {externalLinks ? (
                                                externalLinks
                                                  ?.slice(0, 5)
                                                  .map((e, index) => (
                                                    <div
                                                      key={index}
                                                      className="internal-and-external-links-outer-div"
                                                    >
                                                      <div>
                                                        <Badge
                                                          pill
                                                          variant="secondary"
                                                          className="badge-for-external-and-internal-links"
                                                        >
                                                          {" "}
                                                          {e[1]}
                                                        </Badge>
                                                      </div>
                                                      <div className="ml-2">
                                                        <small>
                                                          <a
                                                            target="_blank"
                                                            href={e[0]}
                                                          >
                                                            {e[0]}
                                                          </a>{" "}
                                                        </small>
                                                      </div>
                                                    </div>
                                                  ))
                                              ) : (
                                                <div></div>
                                              )}
                                            </div>

                                            {showFullListOfExternalLinks ===
                                            false ? (
                                              <div
                                                style={{ maxWidth: "450px" }}
                                                className="mt-4"
                                                onClick={
                                                  showFullListOfExternalLinksFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Show the whole list of
                                                  outgoing links
                                                </span>
                                              </div>
                                            ) : (
                                              <div
                                                className="mt-4"
                                                onClick={
                                                  hideFullListOfExternalLinksFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Hide the whole list of
                                                  outgoing links
                                                </span>
                                              </div>
                                            )}
                                            {showFullListOfExternalLinks ===
                                            true ? (
                                              <div
                                                className="pt-4"
                                                style={{ maxWidth: "450px" }}
                                              >
                                                <strong>
                                                  These are all the outgoing
                                                  links:{" "}
                                                </strong>
                                                <div className="mb-2"></div>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  {externalLinks?.map(
                                                    (e, index) => (
                                                      <div
                                                        key={index}
                                                        className="internal-and-external-links-outer-div"
                                                      >
                                                        <div
                                                          className={e.index}
                                                        >
                                                          <Badge
                                                            pill
                                                            variant="secondary"
                                                            className="badge-for-external-and-internal-links"
                                                          >
                                                            {" "}
                                                            {e[1]}
                                                          </Badge>
                                                        </div>
                                                        <div className="ml-2">
                                                          <small>
                                                            <a
                                                              target="_blank"
                                                              href={e[0]}
                                                            >
                                                              {e[0]}
                                                            </a>{" "}
                                                          </small>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </span>
                                              </div>
                                            ) : (
                                              <></>
                                            )}

                                            <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                When a link is pointing to a
                                                domain that is different from
                                                the domain from where the link
                                                exists on, it is called an
                                                "external link". External links
                                                have impact on search engine
                                                rankings as they are seen as a
                                                vote of confidence.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* OUTGOING NOFOLLOW LINKS SECTION : ************************************************************* */}
                                      <div className="common-seo-issues-inner-div">
                                        <div className="title-div-onsite-result-component">
                                          <div className="flag-and-title-div-onsite-result-component">
                                            {" "}
                                            <i
                                              style={{
                                                color: "#808080",
                                                fontSize: "1.5em",
                                                paddingRight: "0.5em",
                                              }}
                                              className="bi-box-arrow-in-up-right"
                                            ></i>
                                            <div className="meta-title-test-and-overall-recommendation-div">
                                              <strong>
                                                Outgoing{" "}
                                                <span
                                                  style={{
                                                    textDecoration: "underline",
                                                  }}
                                                >
                                                  no-follow
                                                </span>{" "}
                                                links{" "}
                                              </strong>
                                              {/* <small>Site passed favicon test</small> */}
                                            </div>
                                          </div>

                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  A "no-follow" link is a
                                                  hyperlink with a
                                                  rel=“nofollow” tag. No-follow
                                                  links are used to link to a
                                                  page, without giving any
                                                  ranking credit or link-juice
                                                  to that specific site. You can
                                                  read more about no-follow
                                                  links{" "}
                                                  <a href="https://developers.google.com/search/blog/2019/09/evolving-nofollow-new-ways-to-identify">
                                                    here on Google.
                                                  </a>
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {outGoingNoFollowLinks?.length >
                                            0 ? (
                                              <small>
                                                This page has outgoing no-follow
                                                links.
                                                {/* <i
style={{ color: "#4aac48" }}
className="bi bi-hand-thumbs-up"
></i> */}
                                              </small>
                                            ) : (
                                              <small>
                                                This page does not have any
                                                outgoing no-follow links.
                                                {/* <i
style={{ color: "#4aac48" }}
className="bi bi-hand-thumbs-up"
></i> */}
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div>
                                              <strong>
                                                Number of outgoing no-follow
                                                links:{" "}
                                                {outGoingNoFollowLinks?.length}{" "}
                                              </strong>
                                              <div className="mb-2"></div>
                                            </div>

                                            {showFullListOfOutgoingNoFollowLinks ===
                                            false ? (
                                              <div
                                                style={{ maxWidth: "450px" }}
                                                className="mt-4"
                                                onClick={
                                                  showFullListOfOutgoingNoFollowLinksFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Show the whole list of
                                                  outgoing no-follow links
                                                </span>
                                              </div>
                                            ) : (
                                              <div
                                                className="mt-4"
                                                onClick={
                                                  hideFullListOfOutgoingNoFollowLinksFunction
                                                }
                                              >
                                                <span
                                                  style={{
                                                    fontSize: "14px",
                                                    textDecoration: "underline",
                                                    cursor: "pointer",
                                                  }}
                                                >
                                                  Hide the whole list of
                                                  outgoing no-follw links
                                                </span>
                                              </div>
                                            )}
                                            {showFullListOfOutgoingNoFollowLinks ===
                                            true ? (
                                              <div
                                                className="pt-4"
                                                style={{ maxWidth: "450px" }}
                                              >
                                                <strong>
                                                  These are all the outgoing
                                                  no-follow links:{" "}
                                                </strong>
                                                <div className="mb-2"></div>
                                                <span
                                                  style={{ fontSize: "14px" }}
                                                >
                                                  {outGoingNoFollowLinks?.map(
                                                    (e, index) => (
                                                      <div
                                                        key={index}
                                                        className="internal-and-external-links-outer-div"
                                                      >
                                                        <div
                                                          className={e.index}
                                                        >
                                                          <Badge
                                                            pill
                                                            variant="secondary"
                                                            className="badge-for-external-and-internal-links"
                                                          >
                                                            {" "}
                                                            {index + 1}
                                                          </Badge>
                                                        </div>
                                                        <div className="ml-2">
                                                          <small>
                                                            <a
                                                              target="_blank"
                                                              href={e[0]}
                                                            >
                                                              {e[0]}
                                                            </a>{" "}
                                                          </small>
                                                        </div>
                                                      </div>
                                                    )
                                                  )}
                                                </span>
                                              </div>
                                            ) : (
                                              <></>
                                            )}

                                            <div className="meta-title-recommendations-div-onsite-scraping-results"></div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                A "no-follow" link is a
                                                hyperlink with a rel=“nofollow”
                                                tag. No-follow links are used to
                                                link to a page, without giving
                                                any ranking credit or link-juice
                                                to that specific site. You can
                                                read more about no-follow links{" "}
                                                <a href="https://developers.google.com/search/blog/2019/09/evolving-nofollow-new-ways-to-identify">
                                                  here on Google.
                                                </a>
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                    </div>

                                    {/* SERVER AND SECURITY SECTION ***************************************************/}
                                    <div
                                      className="d-flex common-seo-issues-outer-div mt-3"
                                      style={{ background: "white" }}
                                    >
                                      <div className="top-card-box-onsite-result-component">
                                        <h4>Server and security</h4>
                                      </div>
                                      {/* HTTPS CHECKER SECTION  *****************************************************/}
                                      <div className="common-seo-issues-inner-div">
                                        {/*               <div className="title-div-and-middlemiddle-results-div"> */}

                                        <div className="title-div-onsite-result-component">
                                          {isHttpsSupported === true ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>HTTPS test </strong>
                                                <small>
                                                  Site passed HTTPS test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>HTTPS test </strong>
                                                <small>
                                                  Site did not pass the HTTPS
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  Hypertext Transfer Protocol
                                                  Secure (HTTPS) is an extension
                                                  of the Hypertext Transfer
                                                  Protocol (HTTP). It is used in
                                                  order to make communication
                                                  over a computer network
                                                  secure. HTTPS uses TLS (SSL)
                                                  to encrypt requests and
                                                  responses. Therefore, HTTPS is
                                                  much more secure than HTTP.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {isHttpsSupported === true ? (
                                              <small>
                                                This webpage is using HTTPS{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage is not using HTTPS{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {isHttpsSupported === false ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  This website is not using
                                                  HTTPS. This means that users
                                                  are not protected against
                                                  eavesdroppers and
                                                  man-in-the-middle (MitM)
                                                  attacks.
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  This website is successfully
                                                  using HTTPS, which protects
                                                  users against eavesdroppers
                                                  and man-in-the-middle (MitM)
                                                  attacks. Good job 💪
                                                </Alert>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                Hypertext Transfer Protocol
                                                Secure (HTTPS) is an extension
                                                of the Hypertext Transfer
                                                Protocol (HTTP). It is used in
                                                order to make communication over
                                                a computer network secure. HTTPS
                                                uses TLS (SSL) to encrypt
                                                requests and responses.
                                                Therefore, HTTPS is much more
                                                secure than HTTP.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>

                                      {/* LINE BREAK: */}
                                      <div className="top-card-box-onsite-result-component"></div>

                                      {/* SSL INFO SECTION *************************************************************** */}
                                      <div className="common-seo-issues-inner-div">
                                        {/*               <div className="title-div-and-middlemiddle-results-div"> */}

                                        <div className="title-div-onsite-result-component">
                                          {sslInfo?.valid === true ? (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "#4aac48",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>SSL test </strong>
                                                <small>
                                                  Site passed SSL certificate
                                                  test
                                                </small>
                                              </div>
                                            </div>
                                          ) : (
                                            <div className="flag-and-title-div-onsite-result-component">
                                              {" "}
                                              <i
                                                style={{
                                                  color: "red",
                                                  fontSize: "1.5em",
                                                  paddingRight: "0.5em",
                                                }}
                                                className="bi bi-flag"
                                              ></i>
                                              <div className="meta-title-test-and-overall-recommendation-div">
                                                <strong>SSL test </strong>
                                                <small>
                                                  Site did not pass the SSL
                                                  certificate test
                                                </small>
                                              </div>
                                            </div>
                                          )}
                                          <div className="overlay-trigger-div-that-is-only-shown-on-small-screens">
                                            <OverlayTrigger
                                              key="left"
                                              placement="left"
                                              overlay={
                                                <Tooltip
                                                  id={`tooltip-${"left"}`}
                                                >
                                                  Secure Sockets Layer (SSL) is
                                                  the standard technology for
                                                  keeping an internet connection
                                                  secure. SSL is using an
                                                  encryption algorithms when
                                                  sending data, which prevents
                                                  hackers from reading it.
                                                </Tooltip>
                                              }
                                            >
                                              <i className="bi bi-info-circle"></i>
                                              {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                            </OverlayTrigger>
                                          </div>
                                        </div>
                                        <div className="meta-title-report-to-the-right">
                                          <div className="webpage-using-a-meta-title-or-not-div">
                                            {sslInfo?.valid === true ? (
                                              <small>
                                                This webpage is using SSL
                                                certificate{" "}
                                                <i
                                                  style={{ color: "#4aac48" }}
                                                  className="bi bi-hand-thumbs-up"
                                                ></i>
                                              </small>
                                            ) : (
                                              <small>
                                                This webpage might not have a
                                                valid SSL certificate{" "}
                                                <i
                                                  style={{ color: "red" }}
                                                  className="bi bi-hand-thumbs-down"
                                                ></i>
                                              </small>
                                            )}
                                          </div>
                                          <div className="meta-title-and-meta-title-length-div">
                                            {sslInfo?.valid === true ? (
                                              <div>
                                                <div
                                                  style={{ display: "flex" }}
                                                >
                                                  <strong>
                                                    SSL certificate valid
                                                    from:&nbsp;
                                                  </strong>{" "}
                                                  <p style={{ margin: "0" }}>
                                                    {SSLValidFrom}
                                                  </p>
                                                </div>
                                                <div
                                                  style={{ display: "flex" }}
                                                >
                                                  <strong>
                                                    SSL certificate valid
                                                    to:&nbsp;
                                                  </strong>{" "}
                                                  <p style={{ margin: "0" }}>
                                                    {SSLValidTo}
                                                  </p>
                                                </div>
                                                <div>
                                                  <strong>
                                                    Days remaining:{" "}
                                                  </strong>
                                                  <span
                                                    style={{ fontSize: "14px" }}
                                                  >
                                                    {sslInfo?.daysRemaining}
                                                  </span>
                                                </div>
                                                <div>
                                                  <strong>
                                                    SSL certificate is valid for
                                                    these domains:{" "}
                                                  </strong>
                                                  <span
                                                    style={{ fontSize: "14px" }}
                                                  >
                                                    {sslInfo?.validFor.map(
                                                      (e) => e + ", "
                                                    )}
                                                  </span>
                                                </div>
                                              </div>
                                            ) : (
                                              <div></div>
                                            )}
                                            <div className="meta-title-recommendations-div-onsite-scraping-results">
                                              {sslInfo?.valid === true ? (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-success"
                                                  variant={"success"}
                                                >
                                                  This website has a valid SSL
                                                  certificate, which helps with
                                                  keeping sensitive information
                                                  like usernames, passwords,
                                                  credit cards, etc. secure by
                                                  encrypting the data. Good job
                                                  💪
                                                </Alert>
                                              ) : (
                                                <Alert
                                                  style={{ margin: "0" }}
                                                  className="alert-messages-meta-checker-danger"
                                                  variant={"danger"}
                                                >
                                                  This website might not have a
                                                  valid SSL certificate.
                                                  <br></br>
                                                  <br></br>
                                                  To be 100% sure - be sure you
                                                  are using the root domain when
                                                  testing for <b>
                                                    {urlInput}
                                                  </b>{" "}
                                                  without any "/" in the end.
                                                  <br></br>
                                                  <br></br>Browsers might block
                                                  the website and warn users
                                                  that the website cannot be
                                                  trusted if you do not have a
                                                  valid SSL certificate.
                                                  <br></br>
                                                  <br></br> This should be fixed
                                                  immediately.
                                                </Alert>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                        {/* </div> */}
                                        <div className="overlay-trigger-div-only-shown-on-large-screens">
                                          <OverlayTrigger
                                            key="left"
                                            placement="left"
                                            overlay={
                                              <Tooltip id={`tooltip-${"left"}`}>
                                                Secure Sockets Layer (SSL) is
                                                the standard technology for
                                                keeping an internet connection
                                                secure. SSL is using an
                                                encryption algorithms when
                                                sending data, which prevents
                                                hackers from reading it.
                                              </Tooltip>
                                            }
                                          >
                                            <i className="bi bi-info-circle"></i>
                                            {/*                     <Button variant="secondary">Tooltip on </Button> */}
                                          </OverlayTrigger>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* //THIS IS THE BOX TO THE RIGHT THAT IS ONLY SHOWN ON BIG SCREENS  */}
                                {/*  {firstTimeUser === true ? (
                            <div></div>
                          ) : (
                            <div
                              className="box-to-the-right-with-the-overall-results-onsite-scraper"
                              style={{ background: "white" }}
                            >
                              <div className="inner-div-box-to-the-right-with-the-overall-results-onsite-scraper">
                                {metaTitle?.length >= 30 &&
                                metaTitle?.length <= 65 ? (
                                  <div className="flag-and-title-div-onsite-result-component">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Meta title test </strong>
                                      <small>Site passed meta title test</small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Meta title test </strong>
                                      <small>
                                        Site did not pass meta title test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {metaDescription?.length >= 120 &&
                                metaDescription?.length <= 160 ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Meta description test </strong>
                                      <small>
                                        Site passed meta description test
                                      </small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Meta description test </strong>
                                      <small>
                                        Site did not pass meta description test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {h1Length === 1 ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Heading tags test </strong>
                                      <small>Site passed headings test</small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Heading tags test </strong>
                                      <small>
                                        Site did not pass headings test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {numberOfEmptyAltTexts < 1 ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Image Alt text test </strong>
                                      <small>
                                        Site passed image Alt text test
                                      </small>
                                    </div>
                                  </div>
                                ) : numberOfEmptyAltTexts < 5 ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#a1a102",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Image Alt text test </strong>
                                      <small>
                                        Site has some small issues regarding
                                        image Alt texts
                                      </small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Image Alt text test </strong>
                                      <small>
                                        Site did not pass the image Alt texts
                                        test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {robotsTXTExists === true ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Robots.txt test </strong>
                                      <small>
                                        Site passed the Robots.txt test
                                      </small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Robots.txt test </strong>
                                      <small>
                                        Site did not pass the Robots.txt test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {faviconFromWebsite?.length > 1 ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Favicon test </strong>
                                      <small>
                                        Site passed the favicon test
                                      </small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>Favicon test </strong>
                                      <small>
                                        Site did not pass the favicon test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {isHttpsSupported === true ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>HTTPS test </strong>
                                      <small>Site passed the HTTPS test</small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>HTTPS test </strong>
                                      <small>
                                        Site did not pass the HTTPS test
                                      </small>
                                    </div>
                                  </div>
                                )}
                                {sslInfo?.valid === true ? (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "#4aac48",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>SSL test </strong>
                                      <small>Site passed the SSL test</small>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="flag-and-title-div-onsite-result-component mt-2">
                                    {" "}
                                    <i
                                      style={{
                                        color: "red",
                                        fontSize: "1.5em",
                                        paddingRight: "0.5em",
                                      }}
                                      className="bi bi-flag"
                                    ></i>
                                    <div className="meta-title-test-and-overall-recommendation-div">
                                      <strong>SSL test </strong>
                                      <small>
                                        Site did not pass the SSL test
                                      </small>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          )} */}
                              </Col>
                            </Row>
                          </Container>
                        </Content>
                      </Modal>
                    </main>
                  </section>
                </Content>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default QuickReportsPage;
